import axios from "axios";
import { pascalCase } from "pascal-case";

const baseHref = (document.querySelector("base") || {}).href || "/";

const apiClient = axios.create({
  // eslint-disable-next-line camelcase,no-undef
  baseURL: `${baseHref}api`,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
});

export default {
  async getDefaultForm(webformId) {
    return this.getForm(webformId, "en");
  },

  async getForm(webformId, lang) {
    const { data } = await apiClient.get(`/webform/${pascalCase(webformId)}/${lang}`);
    if (data && data.logo) {
      // eslint-disable-next-line camelcase,no-undef
      data.logo = `${baseHref}${data.logo.replace(/^\//, "")}`;
    }
    return data;
  },

  async submitWebform({ webformId, ...model }) {
    const now = new Date();
    const tzOffset = 0 - now.getTimezoneOffset() / 60;
    const tz = tzOffset > 0 ? `(GMT+${tzOffset})` : `(GMT${tzOffset})`;
    const { data } = await apiClient.post("/webform", {
      ...model,
      webformId: pascalCase(webformId),
      userAgent: navigator.userAgent || "unknown",
      browserDate: (now && now.toLocaleString) ? `${now.toLocaleString()}` : "",
      browserTimezone: tz,
    });
    // console.log("webform response", data);
    const { token } = data;
    const message = data.message || "Webform Submitted";
    return { token, message };
  },

  async sendAttachment(token, { name, type, data }, webformId, onUploadProgress) {
    await apiClient.post("/upload", {
      attachments: [{ name, type, data }],
      webformId: pascalCase(webformId),
    }, {
      onUploadProgress,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
